import { useMutation } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import type { OrgModelConfigFilter } from "../OrgLlmProviderRecord";

/**
 * Resolve every org id matching a model-configuration filter, for "select
 * all matching". A mutation because it runs on demand, and its answer is only
 * good for the moment it is asked.
 */
export function useSearchOrgModelConfigIds() {
  const { orgService } = useDomainServices();

  return useMutation<string[], Error, OrgModelConfigFilter>({
    mutationFn: (filter) => orgService.searchOrgModelConfigIds(filter),
  });
}
